module.exports = __webpack_public_path__ + "static/img/default-avatar.e18c7a6.png";